// Copyright (c) StrangeBee 2024

import React, { ReactElement, useContext } from 'react';
import { CaseTemplateOutput } from 'thehive-sdk';
import { useLocalMessage } from '@Helpers/';
import DisplayTag from '@Organisms/DisplayTag/DisplayTag';
import { ICONS } from '@Constants/iconsApp';
import { ScopeContext } from '@Context/ScopeProvider';

import './CaseTemplateListDetails.scss';

interface CaseTemplateListDetailsProps {
    caseTemplate: CaseTemplateOutput;
    onTagClick: (tag: string, event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
}

const CaseTemplateListDetails = ({ caseTemplate, onTagClick }: CaseTemplateListDetailsProps): ReactElement => {
    const i = useLocalMessage();

    const { name = '', displayName = '', tags = [] } = caseTemplate;

    const { coloredTags } = useContext(ScopeContext);

    return (
        <div className="case-template-list-details">
            <div className="case-template-list-details__name">{displayName || name}</div>
            <div className="case-template-list-details__tags">
                {<ICONS.TagsOutlined className="case-template-list-details__icon" />}
                {tags.length ? (
                    <DisplayTag.List<string> data={tags}>
                        {(tag) => (
                            <DisplayTag
                                tag={tag}
                                onClick={(tag, event): void => onTagClick(tag, event)}
                                color={coloredTags[tag]}
                            />
                        )}
                    </DisplayTag.List>
                ) : (
                    i('general.none')
                )}
            </div>
        </div>
    );
};

export default CaseTemplateListDetails;
